import _ from "lodash";
import router from '@/router'

const state = {
  live: {},
  event: null,
  eventLoader: false,
  changes: {},
  sports: {},
}
const getters = {
  live(state) {
    return state.live
  },
  event(state) {
    return state.event
  },
  eventLoader(state) {
    return state.eventLoader
  },
  changes(state){
    return state.changes;
  },
}
const mutations = {
  SET_LIVE(state, payLoad){
    state.live = payLoad;
  },
  SET_EVENT_LOADER(state, payLoad){
    state.eventLoader = payLoad;
  },
  SET_EVENT(state, payLoad){
    state.event = payLoad;
    if(payLoad == null){
      router.replace({ query: {}});
    }
  },

  /* MARKET */
  MARKET_CHANGE (state, payLoad) {
    var isCalendar = (
      state.live[payLoad.sid] &&
      state.live[payLoad.sid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]
    );
    var isEvent = (
      (state.event && (state.event.id == payLoad.eid || state.event.eid == payLoad.eid))
      &&
      state.event.m[payLoad.mid]
    );

    if(
        isCalendar
        ||
        isEvent
      )
    {

      _.forEach(payLoad.data['d'], function(value, key) 
      {
        _.forEach(value, function(valueD, keyD) 
        {
          _.forEach(valueD, function(valuex, k)
          {
            
            if(isEvent)
            {
              var change_class = null;

              if(k == 'or')
              {
                if(
                  !_.isUndefined(state.event['m']) &&
                  !_.isUndefined(state.event['m'][payLoad.mid]) &&
                  !_.isUndefined(state.event['m'][payLoad.mid]['d']) &&
                  !_.isUndefined(state.event['m'][payLoad.mid]['d'][key]) &&
                  !_.isUndefined(state.event['m'][payLoad.mid]['d'][key][keyD]) &&
                  !_.isUndefined(state.event['m'][payLoad.mid]['d'][key][keyD][k]) &&
                  valuex != state.event.m[payLoad.mid]['d'][key][keyD][k]
                )
                {
                  change_class = 'down';

                  if(valuex > state.event.m[payLoad.mid]['d'][key][keyD][k])
                  {
                    change_class = 'up';
                  }

                  state.event.m[payLoad.mid]['d'][key][keyD]['change'] = change_class; //NEW class
                  
                  removeMarketChangeClass(payLoad, key, keyD, true);

                }
                else
                {
                  //console.log('NO-DATA',payLoad, state.event['m'][payLoad.mid]['d'] ,'NO-DATA-END')
                }
              }

              if(
                !_.isUndefined(state.event) &&
                !_.isUndefined(state.event['m']) &&
                !_.isUndefined(state.event['m'][payLoad.mid]) &&
                !_.isUndefined(state.event['m'][payLoad.mid]['d']) &&
                !_.isUndefined(state.event['m'][payLoad.mid]['d'][key]) &&
                !_.isUndefined(state.event['m'][payLoad.mid]['d'][key][keyD])
              )
              {
                state.event['m'][payLoad.mid]['d'][key][keyD][k] = valuex; //New Value
              }
            
            }


            if(isCalendar)
            {
              var change_class = null;

              if(k == 'or')
              {
                if(
                  !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d']) 
                  && 
                  !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key]) 
                  && 
                  !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD]) 
                  && 
                  !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD][k]) 
                  && 
                  valuex != state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD][k]
                )
                {
                  change_class = 'down';
  
                  if(valuex > state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD][k])
                  {
                    change_class = 'up';
                  }
                  
                  state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD]['change'] = change_class;
                  
                  removeMarketChangeClass(payLoad, key, keyD);
                }
              }

              if(!_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD]) && !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD][k]))
              {
                state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD][k] = valuex;
              }
            }
          });
        });

      });
    }
  },
  MARKET_ADD (state, payLoad, market_id) 
  {

    if(!_.isEmpty(payLoad['data']))
    {
      _.forEach(payLoad.data.d, function(value, key) {
        if(
          state.live[payLoad.sid] &&
          state.live[payLoad.sid]['d'] &&
          state.live[payLoad.sid]['d'][payLoad.lid] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]
          )
        {

          if(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'] && _.isEmpty(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m']))
          {
            //console.log('NO_MARKET_ADD  | SportId: ' + payLoad.sid + ' | EventId: '  + payLoad.eid + ' | MarketId: ' + payLoad.market_id + ' | MID: ' + payLoad.mid);

            if(payLoad.mid == payLoad.market_id)
            {
              var mid = payLoad.market_id;
              //console.log('MARKET_ADD  | SportId: ' + payLoad.sid + ' | EventId: '  + payLoad.eid + ' | MarketId: ' + payLoad.market_id + ' | MID: ' + payLoad.mid);
              state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'] = {[mid]: payLoad.data};
            }
          }

          if(!_.isNull(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn']))
          {
            state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn'] = parseInt(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn']) + 1;
          }
          else
          {
            state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn'] = 1;
          }


          //state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key].push(value);
          //state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['m'] = payLoad.data.m

          if(state.event && state.event.eid == payLoad.eid)
          {
            state.event['m'][payLoad.mid]['d'][key] = value;
            state.event['m'][payLoad.mid]['m'] = payLoad.data.m
          }

        }
      });
    }
  },
  MARKET_REMOVE (state, payLoad) {
    if(!_.isEmpty(payLoad['data']) && !_.isEmpty(payLoad['data']['s']))
    {
      _.forEach(payLoad['data']['s'], function(value, key) {
        if(
          state.live[payLoad.sid] &&
          state.live[payLoad.sid]['d'] &&
          state.live[payLoad.sid]['d'][payLoad.lid] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid][key]
          )
        {
          //_.unset(state.live, [payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid][key]);
          delete state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid][key];
          if(state.event && state.event.eid == payLoad.eid)
          {
            //_.unset(state.event, ['m'][payLoad.mid][key]);
            delete state.event['m'][payLoad.mid][key];
          }

          if(!_.isNull(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn']))
          {
            state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn'] = parseInt(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn']) - 1;
          }
          else
          {
            state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['mcn'] = 0;
          }

        }
      });
    }
  },
  /* MARKET */

  /* CALENDAR */
  CALENDAR_CHANGE (state, payLoad) {
    if(
      state.live[payLoad.sid] &&
      state.live[payLoad.sid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]
      )
    {
      _.forEach(payLoad.data, function(value, key) 
      {
          if(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid][key])
          {
            state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid][key] = value;
          }

          if(state.event && (state.event.id == payLoad.eid || state.event.eid == payLoad.eid))
          {
            if(state.event[key])
            {
              state.event[key] = value;
            }
          }
      });
    }
  },
  CALENDAR_ADD (state, payLoad) 
  {
    if(
      state.live[payLoad.sid] &&
      state.live[payLoad.sid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d']
      )
    {
      //console.log('%c CALENDAR_ADD! ' + payLoad.eid, 'background: #222; color: #bada55');
      //console.log(payLoad)
      if(!_.isEmpty(payLoad.data['m']) || true)
      {
        state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid] = payLoad.data;
      }
      //console.log('%c CALENDAR_ADD_END! ' + payLoad.eid, 'background: #222; color: #bada55');
    }
  },
  CALENDAR_REMOVE (state, payLoad) 
  {
    //console.log('%c CALENDAR_REMOVE! '+ payLoad.sid+ ' -- ' + payLoad.eid, 'background: #DDD; color: red');
    //console.log(payLoad);
    if(
      state.live[payLoad.sid] &&
      state.live[payLoad.sid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]
      )
    {
      //console.log('%c CALENDAR_REMOVED BRO! ' + payLoad.eid, 'background: #FFF; color: green');

      delete state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid];
      //_.unset(state.live, state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]);

      if(state.event && (state.event.id == payLoad.eid || state.event.eid == payLoad.eid))
      {
        commit('SET_EVENT', null);
      }
    }

    //console.log('%c CALENDAR_REMOVE_END! ' + payLoad.eid, 'background: #DDD; color: red');
  },
  /* CALENDAR */

  /* SCORE */
  SCORE_CHANGE (state, payLoad) {
    if(
      state.live[payLoad.sid] &&
      state.live[payLoad.sid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid] &&
      state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['sc']
      )
    {
      _.forEach(payLoad.data, function(value, key) 
      {
        _.forEach(value, function(valueD, keyD) 
        {

          if(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['sc'][key])
          {
            state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['sc'][key][keyD] = payLoad.data[key][keyD];
          }

          if(state.event && (state.event.id == payLoad.eid || state.event.eid == payLoad.eid))
          {
            if(state.event['sc'][key])
            {
              state.event['sc'][key][keyD] = payLoad.data[key][keyD];
            }
          }
        });
      });
    }
  },
  SCORE_ADD (state, payLoad) {
    if(!_.isEmpty(payLoad['data']))
    {
      _.forEach(payLoad.data, function(value, key) {
        if(
          state.live[payLoad.sid] &&
          state.live[payLoad.sid]['d'] &&
          state.live[payLoad.sid]['d'][payLoad.lid] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid] &&
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['sc']
          )
        {
          state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['sc'][key] = value;
          if(state.event && (state.event.id == payLoad.eid || state.event.eid == payLoad.eid))
          {
            state.event['sc'][key] = value;
          }
        }
      });
    }
  },
  /* SCORE */

  /* HEARTBEAT */
  HEARTBEAT_HEARTBEAT (state, payLoad) {
  },
  /* HEARTBEAT */
}
const actions = {
  feed: ({ commit, getters, rootState, rootGetters }, payLoad) => {
    
    payLoad.market_id = null;

    if(payLoad.category == 'market' && payLoad.action == 'add')
    {
      payLoad.market_id = rootGetters['translate/sportFilter'](payLoad.sid);
    }

    commit((payLoad.category+'_'+payLoad.action).toUpperCase(), payLoad)
  },
  fetchFullData({ commit, dispatch, state}){
    axios.get('/sportsbook/live').then((response) => {
      commit('SET_LIVE', response.data)
    })
    .catch((c) => {})
    .finally((f) => { 
    })
  },
  fetchEvent({ commit, dispatch, state}, payLoad){
    commit('SET_EVENT_LOADER', true)
    commit('SET_EVENT', null)
    
    axios.get('/sportsbook/live/' + payLoad).then((response) => {
      commit('SET_EVENT', response.data)
      router.replace({ query: { id: state.event.id }});
    })
    .catch((c) => {
      commit('SET_EVENT', null);
    })
    .finally((f) => { 
      commit('SET_EVENT_LOADER', false)
    })
  },
  clearEvent()
  {
    commit('SET_EVENT', null)
  }
}

function removeMarketChangeClass(payLoad, key, keyD, isEvent = false)
{  
  setTimeout(() => {
    if(isEvent)
    {
      if(
        !_.isNull(state.event) &&
        !_.isUndefined(state.event['m']) && 
        !_.isUndefined(state.event['m'][payLoad.mid]) && 
        !_.isUndefined(state.event['m'][payLoad.mid]['d']) && 
        !_.isUndefined(state.event['m'][payLoad.mid]['d'][key]) &&
        !_.isUndefined(state.event['m'][payLoad.mid]['d'][key][keyD])
        )
      {
        state.event['m'][payLoad.mid]['d'][key][keyD]['change'] = null;
      }
    }
    else
    {
      if(
        !_.isUndefined(state.live[payLoad.sid]) && 
        !_.isUndefined(state.live[payLoad.sid]['d']) && 
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d']) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m']) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d']) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key]) &&
        !_.isUndefined(state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD])
        )
      {
        state.live[payLoad.sid]['d'][payLoad.lid]['d'][payLoad.eid]['m'][payLoad.mid]['d'][key][keyD]['change'] = null;
      }
      
    }
  }, 5000);
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}